import { computed, watchEffect, onUnmounted, unref, isRef } from 'vue'
import store from '@/store'

export function useHead(innerTitle) {  
    const _unref = val => (isRef(val) ? val.value : val)

    const teatro = computed(() => store.getters.getTeatro)
    const configuracion = computed(() => store.getters.getConfig)

    const ENV_TITLE = process.env.VUE_APP_URL_TITLE || ''

    // Calculamos el título completo
    const fullTitle = computed(() => {
        const rawTitle = _unref(innerTitle)
        const complement = teatro.value?.meta_title || configuracion.value?.title || ENV_TITLE
        
        return rawTitle 
            ? `${rawTitle} | ${complement}` 
            : complement
    })
    
    const ENV_DESC = process.env.VUE_APP_URL_DESCRIPTION || 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada';

    // Calculamos la descripción
    const description = computed(() => {
        const defaultDesc = ENV_DESC
        return teatro.value?.meta_description || defaultDesc
    })

    // Calculamos el nombre de la aplicación
    const appName = computed(() => {
        const baseTitle = configuracion.value?.title ? (configuracion.value.title + ' - Venta Oficial de entradas') : ''
        return teatro.value?.meta_title || baseTitle
    })
    
    const stop = watchEffect(() => {
        document.title = fullTitle.value

        const metasToUpdate = [
            { name: 'description', content: description.value },
            { name: 'application-name', content: appName.value }
        ]

        metasToUpdate.forEach(metaDef => {
            let tag = document.querySelector(`meta[name="${metaDef.name}"]`)

            if (tag) {
                tag.setAttribute('content', metaDef.content)
            } else {
                tag = document.createElement('meta')
                tag.setAttribute('name', metaDef.name)
                tag.setAttribute('content', metaDef.content)
                if (metaDef.name === 'description') tag.setAttribute('id', 'desc')            
                document.head.appendChild(tag)
            }
        })

        const link = [
            { rel: 'icon', href: process.env.VUE_APP_URL_FAVICON , sizes: '16x16', type: 'image/png' }, 
        ]

        link.forEach(linkDef => {
            const rel = linkDef.rel
            const href = linkDef.href
            
            let tag = document.querySelector(`link[href="${href}"]`)

            if (!tag) {
                tag = document.createElement('link')
                tag.setAttribute('rel', rel)
                tag.setAttribute('href', href)
                
                if (linkDef.sizes) tag.setAttribute('sizes', linkDef.sizes)
                if (linkDef.type) tag.setAttribute('type', linkDef.type)

                document.head.appendChild(tag)
            }
        })
    })

    onUnmounted(() => {
        stop()
    })
}